/// ./src/app/global-error.js
'use client';

import { useEffect } from 'react';
import Rollbar from 'rollbar';
import { clientConfig } from '@/rollbar';

import reportErrorDebounced from '@hub/common/src/reportErrorDebounced';
import { getLogger } from '@hub/common/src/logger';

import Navbar from '@/components/Navbar';
import ErrorMessage from '@hub/common-components/src/ErrorMessage';
import { CitOrigin } from '@hub/common/src/types/cit-public-api';

import '../styles/index.css';

// catches errors that occur in root layout page
export default function GlobalError({ error, _reset }: { error: Error; _reset: () => void }) {
  useEffect(() => {
    const logger = getLogger(CitOrigin.HUB);
    logger.error({
      event: 'Error in global-error.tsx',
      error,
      citOrigin: CitOrigin.HUB
    });
    const rollbar = new Rollbar(clientConfig);
    reportErrorDebounced(error, rollbar);
  }, [error]);

  return (
    <html>
      <body>
        <Navbar disableSearch={true} />
        <ErrorMessage
          message='Unexpected Error'
          subTitle='Oops! Something went wrong.'
          citOrigin='hub'
        />
      </body>
    </html>
  );
}
